export const ValidationMessage = {
    ANY_CHOOSE: "please choose",
    UNSUPPORTED: "unsupported file",
    Field: (value) => `${value} is required`
}